import { Button, Ui } from '@silvertours/front-shared';
import { useTranslations } from 'next-intl';
import { FloatingSize, LockIcon, UserIcon } from './LoginButton.styles';
import { LoggedInActions } from '../LoggedInActions';
import { useLogin } from '../../../LoginForm';

type Props = {
  onClick?: () => void;
  /** Shows the lock icon also on wide screens (floating header). */
  showIconOnDesktop?: boolean;
  /** `floating` gives the button the size of the floating header design. */
  appearance?: 'default' | 'floating';
};

const LoginButton = ({
  onClick,
  showIconOnDesktop = false,
  appearance = 'default',
}: Props) => {
  const { isLoggedIn, setShowLogin } = useLogin();
  const t = useTranslations('features.navigationLegacy.login');

  const handleLoginClick = () => {
    if (typeof onClick === 'function') {
      onClick();
    }
    setShowLogin(true);
  };

  const button = !isLoggedIn ? (
    <Button
      key="logged-out-actions"
      icon={<LockIcon $showOnDesktop={showIconOnDesktop} />}
      variant="secondary"
      size="small"
      onClick={handleLoginClick}
      data-testid="accountMenuButton"
    >
      {t('menu.button.loggedOut')}
    </Button>
  ) : (
    <Ui.Popover
      key="logged-in-actions"
      button={{
        as: Button,
        icon: <UserIcon />,
        variant: 'secondary',
        size: 'small',
        children: t('menu.button.loggedIn'),
        'data-testid': 'accountMenuButton',
      }}
    >
      <Ui.PopoverPanel>
        <LoggedInActions />
      </Ui.PopoverPanel>
    </Ui.Popover>
  );

  return appearance === 'floating' ? (
    <FloatingSize>{button}</FloatingSize>
  ) : (
    button
  );
};

export { LoginButton };
